import React from "react";
import { Table } from "antd";
import EwaybillTypeNameMap from "@/map/EwaybillTypeNameMap";
import LogisticsCompany from "@/map/LogisticsCompanyNameMap";

const columns = [
  {
    title: "快递单号",
    dataIndex: "waybillNo",
  },
  {
    title: "打印时间",
    dataIndex: "dateCreated",
  },
  {
    title: "面单账号",
    dataIndex: "platformUsername",
    render: (text, record, index) => {
      return (
        <span>
          {text}({EwaybillTypeNameMap[record.type]})
        </span>
      );
    },
  },
  {
    title: "物流公司",
    dataIndex: "logisticsCompany",
    render(text, record, index) {
      return <span>{LogisticsCompany[text]}</span>;
    },
  },
  {
    title: "使用面单的人",
    dataIndex: "consumerCompanyName",
    render(text, record, index) {
      return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <div>
            <span className="fw700">{record.consumerName}</span>
          </div>

          <div className={"attentionColor"}>微信：{text}</div>
        </div>
      );
    },
  },
  {
    title: "单号状态",
    dataIndex: "status",
    render(text, record, index) {
      return <span>{text === "CANCELED" ? "已取消单号" : "有效单号"}</span>;
    },
  },
];

export default function MyTable(props) {
  const { dataSource, loading } = props;
  return (
    <Table
      size="small"
      columns={columns}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      locale={{ emptyText: "没有查询到任何数据" }}
      loading={loading}
      pagination={false}
    />
  );
}
